function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
    id: "404_svg__a",
    d: "M.28.92h6.624v6.623H.28z"
}), /*#__PURE__*/ React.createElement("path", {
    id: "404_svg__c",
    d: "M.984.92h6.622v6.623H.984z"
}), /*#__PURE__*/ React.createElement("path", {
    id: "404_svg__e",
    d: "M.686.92h6.623v6.623H.686z"
}));
var _ref2 = /*#__PURE__*/ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
}, /*#__PURE__*/ React.createElement("path", {
    fill: "#FFF",
    d: "M-558-276H808v800H-558z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#E1EAFF",
    d: "M18 118.25h20.74l-.532-101.392z"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#3370FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M52.87 118.25h-8.753c-2.97 0-5.377-2.475-5.377-5.526v-89.68c0-3.05 2.407-5.524 5.377-5.524h116.987c2.97 0 5.377 2.473 5.377 5.524v89.68c0 3.051-2.407 5.525-5.377 5.525H96.007"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#BACEFD",
    d: "M50.157 107.192h16.645a2.555 2.555 0 002.555-2.555V37.225a2.555 2.555 0 00-2.555-2.555H50.157a2.555 2.555 0 00-2.555 2.555v67.412a2.555 2.555 0 002.555 2.555m30.457 0h73.892a2.396 2.396 0 002.395-2.396v-67.73a2.395 2.395 0 00-2.395-2.396H80.614a2.396 2.396 0 00-2.396 2.396v67.73a2.396 2.396 0 002.396 2.396"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    strokeDasharray: 4.253,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M91.006 96.91h53.107c.951 0 1.722-.771 1.722-1.722v-48.68c0-.95-.771-1.721-1.722-1.721H91.006c-.951 0-1.722.77-1.722 1.722v48.679c0 .95.771 1.722 1.722 1.722z"
}), /*#__PURE__*/ React.createElement("g", {
    transform: "translate(58 5.08)"
}, /*#__PURE__*/ React.createElement("mask", {
    id: "404_svg__b",
    fill: "#fff"
}, /*#__PURE__*/ React.createElement("use", {
    xlinkHref: "#404_svg__a"
})), /*#__PURE__*/ React.createElement("path", {
    fill: "#F54A45",
    d: "M.28 4.231a3.312 3.312 0 106.624 0 3.312 3.312 0 00-6.623 0",
    mask: "url(#404_svg__b)"
})), /*#__PURE__*/ React.createElement("g", {
    transform: "translate(47 5.08)"
}, /*#__PURE__*/ React.createElement("mask", {
    id: "404_svg__d",
    fill: "#fff"
}, /*#__PURE__*/ React.createElement("use", {
    xlinkHref: "#404_svg__c"
})), /*#__PURE__*/ React.createElement("path", {
    fill: "#FFC400",
    d: "M.984 4.231a3.311 3.311 0 106.622.001 3.311 3.311 0 00-6.622-.001",
    mask: "url(#404_svg__d)"
})), /*#__PURE__*/ React.createElement("g", {
    transform: "translate(37 5.08)"
}, /*#__PURE__*/ React.createElement("mask", {
    id: "404_svg__f",
    fill: "#fff"
}, /*#__PURE__*/ React.createElement("use", {
    xlinkHref: "#404_svg__e"
})), /*#__PURE__*/ React.createElement("path", {
    fill: "#34C724",
    d: "M.686 4.231a3.312 3.312 0 106.623 0 3.312 3.312 0 00-6.623 0",
    mask: "url(#404_svg__f)"
})), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M155.122 47.69H143.46m11.662 4.858H143.46m11.662 4.858h-5.942"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#82A7FC",
    d: "M38.208 25.866h128.814v-6.338a2.67 2.67 0 00-2.67-2.67H40.878a2.67 2.67 0 00-2.67 2.67v6.338z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#805000",
    d: "M198.61 35.36s-1.696 7.483-4.94 11.46c-3.246 3.975 2.47 9.587 2.47 9.587s-.688 5.145-8.756 4.795c-8.069-.35-9.238-6.315-9.238-6.315s8.629-3.859 6.01-5.846c-2.62-1.988-4.198-4.327-2.853-12.629 1.345-8.303 7.309-9.004 12.367-7.835 5.056 1.17 4.94 6.782 4.94 6.782"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#5C3A00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M198.61 35.36s-1.696 7.483-4.94 11.46c-3.246 3.975 2.47 9.587 2.47 9.587s-.688 5.145-8.756 4.795c-8.069-.35-9.238-6.315-9.238-6.315s8.629-3.859 6.01-5.846c-2.62-1.988-4.198-4.327-2.853-12.629 1.345-8.303 7.309-9.004 12.367-7.835 5.056 1.17 4.94 6.782 4.94 6.782z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#795101",
    d: "M214.655 65.754c3.106 6.101 13.26 21.17 10.572 25.263-2.69 4.092-21.738 18.125-21.738 18.125l1.786-17.77 4.677-3.743-2.76-8.02 1.942-19.226s3.68 1.756 5.52 5.371"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#623800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M214.655 65.754c3.106 6.101 13.26 21.17 10.572 25.263-2.69 4.092-21.738 18.125-21.738 18.125l1.786-17.77 4.677-3.743-2.76-8.02 1.942-19.226s3.68 1.756 5.52 5.371z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#805000",
    d: "M198.61 35.36s3.82 1.52 2.416 4.793c-1.404 3.275-4.645 1.953-4.645 1.953l2.228-6.747z"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#5C3A00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M198.61 35.36s3.82 1.52 2.416 4.793c-1.404 3.275-4.645 1.953-4.645 1.953l2.228-6.747z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#1E232A",
    d: "M203.49 30.97c-.02.35-2.816 13.893-13.846 11.142-11.03-2.752-10.35-25.56 3.993-22.294 4.527 1.03 10.301 2.749 9.852 11.152"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#1E232A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M203.49 30.97c-.02.35-2.816 13.893-13.846 11.142-11.03-2.752-10.35-25.56 3.993-22.294 4.527 1.03 10.301 2.749 9.852 11.152z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#805000",
    d: "M185.98 35.477s8.42 3.508 6.081 5.613c-2.339 2.104-7.25-3.042-15.202 0l-21.516 9.822 16.896 2.215-6.394 17.721s-40.203-12.218-32.719-20.871c7.483-8.654 55.847-31.741 57.298-29.503 1.391 2.145-7.096 8.817-7.777 7.635-1.11-1.929 11.168-7.487 11.986-5.262.976 2.652-9.19 10.005-10.17 8.312-1.055-1.822 10.17-5.974 11.34-3.634 1.17 2.338-9.823 7.951-9.823 7.951"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#5C3A00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M185.98 35.477s8.42 3.508 6.081 5.613c-2.339 2.104-7.25-3.042-15.202 0l-21.516 9.822 16.896 2.215-6.394 17.721s-40.203-12.218-32.719-20.871c7.483-8.654 55.847-31.741 57.298-29.503 1.391 2.145-7.096 8.817-7.777 7.635-1.11-1.929 11.168-7.487 11.986-5.262.976 2.652-9.19 10.005-10.17 8.312-1.055-1.822 10.17-5.974 11.34-3.634 1.17 2.338-9.823 7.951-9.823 7.951z"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#3370FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M222.938 26.077l8.994-.355m-12.512-6.358l6.106-6.443m-4.236 9.681l4.84-1.115"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#1E232A",
    d: "M213.85 20.321a8.734 8.734 0 01-8.735 8.734 8.735 8.735 0 118.734-8.734"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#1E232A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M213.85 20.321a8.734 8.734 0 01-8.735 8.734 8.735 8.735 0 118.734-8.734z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#795101",
    d: "M153.646 104.548l-4.21 14.032h54.054l.973-14.032z"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#623800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M153.646 104.548l-4.21 14.032h54.054l.973-14.032z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#FFC400",
    d: "M172.239 53.126s3.26.387 7.575.94c2.63.337 2.699 3.817 7.626 4.643 6.353 1.065 6.525-2.68 8.699-2.302 8.054 1.404 12.995 3.976 12.995 3.976l-1.942 19.226-2.73 24.938h-50.816l18.593-51.42z"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M172.239 53.126s3.26.387 7.575.94c2.63.337 2.699 3.817 7.626 4.643 6.353 1.065 6.525-2.68 8.699-2.302 8.054 1.404 12.995 3.976 12.995 3.976l-1.942 19.226-2.73 24.938h-50.816l18.593-51.42z"
}), /*#__PURE__*/ React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
}, /*#__PURE__*/ React.createElement("path", {
    stroke: "#3370FF",
    d: "M132.197 118.58h82.385"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    d: "M53.133 44.678h10.296m-10.296 4.224h10.296m-10.296 4.224h10.296"
})));
function Svg404(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        width: 250,
        height: 125
    }, props), _ref, _ref2);
}
export default Svg404;
